/**
 * @param {import('axios').AxiosInstance} apiClient
 * @param {object} body
 * @param {import('axios').AxiosRequestConfig} [requestConfig] — e.g. `{ timeout: 120_000 }` for slow create flows
 */
export const createDocumentByTenant = async (apiClient, body, requestConfig = {}) => {
  return apiClient.post('/v1/tenant/document/create', body, requestConfig);
};

/**
 * @param {import('axios').AxiosInstance} apiClient
 * @param {object} body — vault_uuid, optional folder_uuid, pagination, etc.
 */
export const listDocumentsByTenant = async (apiClient, body) => {
  return apiClient.post('/v1/tenant/document/list', body);
};

/**
 * @param {import('axios').AxiosInstance} apiClient
 * @param {string} documentUuid
 */
export const getDocumentByTenantUuid = async (apiClient, documentUuid) => {
  const safeUuid = encodeURIComponent(documentUuid);
  return apiClient.get(`/v1/tenant/document/${safeUuid}`);
};

/**
 * @param {import('axios').AxiosInstance} apiClient
 * @param {{ file_uuid: string, document_uuid: string }} body
 * @param {import('axios').AxiosRequestConfig} [requestConfig]
 */
export const attachDocumentByTenant = async (apiClient, body, requestConfig = {}) => {
  return apiClient.post('/v1/tenant/document/attach', body, requestConfig);
};
